module.exports = __webpack_public_path__ + "media/images/credit-0d38223bebb08a69ebe956adb9f925eb.jpg";